import { BaseProps } from '../../shared';

export enum ProductReferenceTypeEnum {
  'ACCESSORIES',
  'BASE_PRODUCT',
  'CONSISTS_OF',
  'CROSSELLING',
  'DIFF_ORDERUNIT',
  'FOLLOWUP',
  'MANDATORY',
  'OTHERS',
  'SELECT',
  'SIMILAR',
  'SPAREPART',
  'UPSELLING'
}

/**
 * Properties passed to `getProductReferences` API function.
 */
export interface GetProductReferencesProps extends BaseProps {
  productCode: string;
  pageSize?: number;
  referenceType?: keyof typeof ProductReferenceTypeEnum
}
